import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import StringUtils from '../../utils/StringUtils';

import BooksSubmitButton from '../../../components/books/common/buttons/BooksSubmitButton';
import BooksLabeledContainer from '../../../components/books/model1/BooksLabeledContainer';
import BooksFormErrorMessage from '../../../components/books/model1/forms/BooksFormErrorMessage';
import BooksTextInput, {
  TextInputType,
} from '../../../components/books/model1/forms/BooksTextInput';
import secretImage from '../../../../public/static/books/secret.png';
import implPasswordProtectionRepository from '../../../infrastructure/repositories/PasswordProtectionRepository';

import css from './MerchantProductProtectedPage.module.scss';

interface Props {
  className?: string;
  session: string;
  productPublicId: number;
  onSubmit: (result: boolean) => void;
}

interface State {
  password: string;
  posted: boolean;
  posting: boolean;
  result: boolean;
}

class MerchantProductProtectedPage extends React.Component<
  Props & InjectedIntlProps,
  State
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.state = { password: '', posted: false, posting: false, result: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ password: e.currentTarget.value });
  }

  private async handleSubmit() {
    const { session, productPublicId, onSubmit } = this.props;
    const { password } = this.state;
    this.setState({ ...this.state, posting: true });

    const result = await implPasswordProtectionRepository(
      session,
    ).Authentication('product', productPublicId, password);

    this.setState({
      ...this.state,
      posted: true,
      posting: false,
      result: result.isAuthenticate,
    });
    onSubmit(result.isAuthenticate);
  }

  public render() {
    const { className, intl } = this.props;
    const { password, posted, posting, result } = this.state;
    const classes = classNames(css.MerchantProductProtectedPage, className);

    return (
      <div className={classes}>
        <img
          className={css.MerchantProductProtectedPage__Img}
          src={secretImage}
          alt=""
        />
        <dl className={css.MerchantProductProtectedPage__Notes}>
          <dt className={css.MerchantProductProtectedPage__Heading}>
            {intl.formatMessage({ id: 'merchants.secret.notes.heading' })}
          </dt>
          <dd className={css.MerchantProductProtectedPage__Description}>
            {StringUtils.nl2br(
              intl.formatMessage({
                id: 'merchants.secret.notes.description',
              }),
            )}
          </dd>
        </dl>
        <div className={css.MerchantProductProtectedPage__Password}>
          <BooksLabeledContainer
            label={intl.formatMessage({ id: 'merchants.secret.password' })}
            errorStyle={posted && !result}
          >
            <BooksTextInput
              type={TextInputType.Password}
              value={password}
              onChange={this.handleChange}
            />
          </BooksLabeledContainer>
          {posted && !result && (
            <BooksFormErrorMessage>
              {intl.formatMessage({ id: 'merchants.secret.errorMessages' })}
            </BooksFormErrorMessage>
          )}
        </div>
        <BooksSubmitButton
          type="button"
          disabled={!password || posting}
          postable={!posting}
          onClick={this.handleSubmit}
          small={true}
          value={intl.formatMessage({
            id: 'books.submitLabel.ok',
          })}
        >
          {intl.formatMessage({
            id: 'books.submitLabel.ok',
          })}
        </BooksSubmitButton>
      </div>
    );
  }
}
export default injectIntl(MerchantProductProtectedPage);
